const UPLOAD_TYPE = {
  PLACE: 'PLACE',
};

export default UPLOAD_TYPE;
